<script setup></script>

<template>
    <button @click="$emit('onClick')" class="btn btn-success rounded-06">
        <span class="material-icons me-1">add</span>
        <slot />
    </button>
</template>
